import { useState } from 'react';
import {
  CollapseContainer,
  CollapseContent,
  CollapseHeader,
  CollapseTitle,
  CollapseIcon,
} from './styles';

interface CollapseProps {
  title: string;
  children: React.ReactNode;
}

export const Collapse = ({ title, children }: CollapseProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <CollapseContainer>
      <CollapseHeader onClick={() => setIsOpen((p) => !p)}>
        <CollapseTitle>{title}</CollapseTitle>
        <CollapseIcon $isopen={isOpen} />
      </CollapseHeader>
      <CollapseContent $isopen={isOpen}>
        {children}
      </CollapseContent>
    </CollapseContainer>
  );
};
